// Français pour la coque partagée du volet agent.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Fold the chat out': 'Déplier le chat',
  'Fold the chat in': 'Replier le chat',
  'Jump to the latest': 'Aller au plus récent',
  'Enter sends · Shift+Enter starts a new line': 'Entrée envoie · Maj+Entrée nouvelle ligne',
  'Ask →': 'Demander →',
}, 'AgentFlyout');
